import {dialog} from '@/modules/layout'
import {ShortcutsCheatsheetDialog} from '@/modules/shortcuts/components/shortcuts-cheatsheet-dialog/shortcuts-cheatsheet-dialog'

export function openShortcutsCheatsheetDialog() {
  const id = 'shortcuts-cheatsheet'

  try {
    dialog.remove(id)
  } catch {}

  return dialog.open(id, {children: <ShortcutsCheatsheetDialog />, size: 'md'})
}
